/**
 * Storefront Recently Viewed
 *
 * Per-brand list of recently viewed product ids, persisted to
 * localStorage so it survives page reloads. Stays small (capped at 8)
 * and dedupes on push so the most recent visit is always first.
 */

const KEY = (brandId) => `tpo_recent_${brandId}`;
const storage = typeof window !== 'undefined' ? window.localStorage : null;
const MAX = 8;

const safeParse = (raw) => {
  try { return JSON.parse(raw); } catch (_) { return null; }
};

export function loadRecent(brandId) {
  if (!storage || !brandId) return [];
  const raw = storage.getItem(KEY(brandId));
  const data = raw ? safeParse(raw) : null;
  return Array.isArray(data) ? data : [];
}

export function pushRecent(brandId, productId) {
  if (!storage || !brandId || !productId) return;
  const current = loadRecent(brandId);
  const id = String(productId);
  const next = [id, ...current.filter((x) => x !== id)].slice(0, MAX);
  try { storage.setItem(KEY(brandId), JSON.stringify(next)); } catch (_) {}
}

export function clearRecent(brandId) {
  if (!storage || !brandId) return;
  try { storage.removeItem(KEY(brandId)); } catch (_) {}
}
